import { render, staticRenderFns } from "./ShopUsers.vue?vue&type=template&id=0ec19364&"
import script from "./ShopUsers.vue?vue&type=script&lang=js&"
export * from "./ShopUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports